const AmadeusShoppingReq = (req) => {
  const createPassenger = (paxType) => ({
    type: paxType,
  });

  const passengers = [];
  for (let i = 0; i < req.adults; i++) {
    passengers.push(createPassenger("ADULT"));
  }
  for (let i = 0; i < req.chd; i++) {
    passengers.push(createPassenger("CHILD"));
  }
  for (let i = 0; i < req.inf; i++) {
    passengers.push(createPassenger("HELD_INFANT"));
  }

  const searchPayload = {
    search: {
      origin: req.origin,
      destination: req.destination,
      departureDate: req.departureDate,
      ...(req.returnDate && { returnDate: req.returnDate }),
    },
    passengers: passengers,
    sources: "GDS",
    searchCriteria: {
      maxFlightOffers: "25",
      excludedCarrierCodes: ["XY", "TC", "WB", "SA", "F3", "LH", "WY"],
      ...(req.airline && {
        includedCarrierCodes: [req.airline],
      }),
    },
  };

  return searchPayload;
};

const getPricingDetails = (data) => {
  const request = {
    amaClientRef: data.amaClientRef,
    ...data.flightOffers,
  };

  return request;
};

const AmadeusBookingReq = (req, amaClientRef) => {
  const request = {
    amaClientRef: amaClientRef,
    flightOffers: req.flightOffers,
    travelers: req.travelers?.map((traveler, index) => ({
      id: index + 1,
      dateOfBirth: traveler.dob,
      name: {
        firstName: traveler.firstName,
        middleName: traveler.middleName,
        lastName: traveler.lastName,
      },
      gender: traveler.gender.toUpperCase(),
      contact: {
        emailAddress: traveler.email,
        phones: [
          {
            deviceType: "MOBILE",
            countryCallingCode: traveler?.telephone?.countryCode,
            number: traveler?.telephone?.number,
          },
        ],
      },
    })),
  };

  return request;
};

export { AmadeusShoppingReq, getPricingDetails, AmadeusBookingReq };
